import { apiFetch } from '@/lib/api'

// Social posts: the AI writes, the owner edits, then Post now or Schedule.

export interface SocialNetwork {
  key: string
  label: string
  /** Connected and supported: can be picked. */
  ready: boolean
  /** Why it can't be picked yet. */
  why: string
  needs_image: boolean
  needs_title: boolean
  limit: number
}

export interface SocialResult {
  network: string
  label: string
  ok?: boolean
  url?: string
  error?: string
  at?: string
  /** Instagram only: the image AI made for the post when none was given. */
  image?: string
}

export interface SocialPost {
  id: number
  text: string
  title: string
  image_url: string
  networks: string[]
  subreddit: string
  status: 'scheduled' | 'posting' | 'posted' | 'partly' | 'failed' | 'cancelled'
  status_label: string
  scheduled_for: string | null
  posted_at: string | null
  created_at: string
  results: SocialResult[]
}

export interface NewSocialPost {
  text: string
  title?: string
  image_url?: string
  networks: string[]
  subreddit?: string
  /** ISO time to schedule; leave out to post now. */
  at?: string
}

export const fetchSocialNetworks = () =>
  apiFetch<{ networks: SocialNetwork[]; types: Array<{ key: string; label: string }> }>(
    '/api/admin/ai-team/social/networks/'
  )

export const writeSocialPost = (body: {
  topic: string
  networks: string[]
  /** Type of post (announcement, promotion…). */
  kind?: string
  instruction?: string
  current?: string
}) =>
  apiFetch<{ text: string; title: string }>('/api/admin/ai-team/social/write/', { method: 'POST', body })

/** An image from a description (AI) or from a picked file (as a data URI). */
export const socialImage = (body: { prompt: string } | { data_uri: string }) =>
  apiFetch<{ url: string }>('/api/admin/ai-team/social/image/', { method: 'POST', body })

export const fetchSocialPosts = (page = 1) =>
  apiFetch<{ posts: SocialPost[]; page: number; pages: number; total: number }>(
    `/api/admin/ai-team/social/posts/?page=${page}`
  )

export const createSocialPost = (body: NewSocialPost) =>
  apiFetch<SocialPost>('/api/admin/ai-team/social/posts/', { method: 'POST', body })

export const cancelSocialPost = (id: number) =>
  apiFetch(`/api/admin/ai-team/social/posts/${id}/`, { method: 'DELETE' })

export const retrySocialPost = (id: number) =>
  apiFetch<SocialPost>(`/api/admin/ai-team/social/posts/${id}/retry/`, { method: 'POST' })
